var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"text-center",attrs:{"show":"","variant":_vm.variant}},[_c('h5',{staticClass:"alert-heading"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }